export default "__VITE_ASSET__5X0vNUIY__"